// Shared styled-component primitives used across multiple components.
import styled from 'styled-components';

// Horizontal thumbnail/attachment scroller with thin scrollbar.
// Extend with styled(ThumbnailScroller) to add component-specific margins/gaps.
export const ThumbnailScroller = styled.div`
	display: flex;
	overflow-x: auto;
	overflow-y: hidden;
	scrollbar-width: thin;
	gap: 8px;
	padding-top: 1px;
	padding-bottom: 4px;
	-webkit-overflow-scrolling: touch;
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};

	&::-webkit-scrollbar {
		height: 6px;
	}
`;
